var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestImg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b48e2d",
    d: "M15.4581929 91.4538791L46.006867 79.6020552l1.0851 2.7969-30.5486741 11.8518239z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbad2d",
    d: "M66.7854949 134.5431062l7.7835615-24.329058 2.8572.9141-7.7835615 24.329058z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b48e2d",
    d: "M108.2274236 89.5835274l1.842-2.3679 24.1825734 18.811732-1.842 2.3679z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbad2d",
    d: "M89.9700281 39.8002092l26.473635-25.05573 2.0622 2.1789-26.473635 25.05573zM29.72843 24.526229l1.4212736-2.6429807 32.8932643 17.6884864-1.4212736 2.6429807z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#e0ab4f",
    d: "M53.475 47.667L77 57.5l19.5-20.096L70.999 29z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#765a25",
    d: "M96.5 37.405L96 72.891 77 86l-3-20 3-12.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#846628",
    d: "M53.475 47.667l5.192 30.999L77 85.999V53.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f3d65c",
    d: "M45.333 43.334l20.668 10.999-20.668 15.001-17.666-20.333z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#e4c723",
    d: "M27.667 49v24.667l17.333 19 2.21-16.668-1.877-9.666z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ac923c",
    d: "M66 54.333l2.034 28.08L45 92.666l.333-26.332z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f3d65c",
    d: "M87 57.5l16.667-9.833 20 16.738-15 16.595z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#e4c723",
    d: "M87 57.5l-5.452 25.362 23.785 17.805 3.818-12.36L108.667 78z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ac923b",
    d: "M123.667 64.405L126 85l-20.666 15.667L108.667 78z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#e0ab50",
    d: "M56.517 87.54L77 73.666 96.5 83 77 103.666z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#83662a",
    d: "M56.517 87.54L55 102.891l20 15.775 4.224-11.012L77 100.666z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#755a23",
    d: "M96.5 83v23.667l-21.5 12 2-18z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#e5c723",
    d: "M58.035 128.667l14.966-4.263 3.665 14.263-7.334 2-12.665-2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ac923d",
    d: "M56.667 138.666V150l17.667-2.334 2.334-9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#e3aa4d",
    d: "M127.333 104l11.334 8.376 11.333-9.71L139 97z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#856628",
    d: "M127.333 104L126 115.333l12.666 8.072 2-7.072-2-5.957z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#745b23",
    d: "M138.667 110.377v13.026l8-5.736 3.334-14.995v-.004z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3d75c",
    d: "M113.833 0l-10.666 9.667L117.834 16l10.332-11.166z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#e4c723",
    d: "M103.167 9.667l-1.833 11 16 7.333 2.276-8.334L117.834 13z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ab923b",
    d: "M128.167 4.834l2.167 11.543-13 11.624.5-15z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#e0ab50",
    d: "M3 86l12-5 11 9.333-17 11.334z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#83662a",
    d: "M0 99.854l9 9.523 2-7.709-2-3.001L3 86z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#755a23",
    d: "M26 90.333v13.333l-17 5.71v-10.71z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f3d65c",
    d: "M17.5 14l14.167-6.167 11 8.167L26 23.833z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#e4c723",
    d: "M17.5 14L16 25l12 9.405.835-7.326L26 21.833z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ac923c",
    d: "M42.667 16L40 27l-12 7.405-2-12.572z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestImg2);
export default __webpack_public_path__ + "static/media/testImg2.962f5b70e61e7a6853c5f20fc2609ecf.svg";
export { ForwardRef as ReactComponent };